<template lang="pug">
	.home
		TitleLibrary(:enable-trans="true")
		.sub-title Aquí encontrará libros e investigaciones publicados y soportados por la cámara de comercio de monteria para una lectura mas interactiva.
		.columns
			.column(v-for="(module, index) in modules")
				.card-module(@click="getProjects(module.id)") 
					img.card-img(:src="'https://ccmonteria.org.co'+module.image")
					.card-name {{ module.name }}
		.year-division(v-for="(projectsPar, year) in parseProjects")
			.columns
				.column.is-full 
					.title-col {{ year }}
			.columns
				.column(v-for="(project, index) in projectsPar")
					a.project(target="_blank",:href="project.project_url")
						img(:src="project.image_url")
						.card-title {{ project.title }}
</template>

<script>
// @ is an alias to /src
import TitleLibrary from '@/components/TitleLibrary.vue'
import axios from 'axios'
import {groupBy} from 'lodash'

export default {
	name: 'home',
	components: {
		TitleLibrary
	},
	data(){
		return {
			isLoading: false,
			modules: [
			],
			projects: []
		}
	},
	computed:{
		parseProjects(){
			return groupBy(this.projects,'year')
		}
	},
	methods:{
		getModules(){
			let vm = this
			vm.isLoading = true
			axios.get('https://ccmonteria.org.co/api/projects')
			.then(function(res) {
				vm.modules = res.data.data
			})
			.catch(function() {
				//console.log(err)
			})
			.then(function() {
				vm.isLoading = false
			})
		},
		getProjects(id){
			let vm = this
			vm.isLoading = true
			axios.get('https://ccmonteria.org.co/api/projects/'+id)
			.then(function(res) {
				vm.projects = res.data.data
			})
			.catch(function() {
				//console.log(err)
			})
			.then(function() {
				vm.isLoading = false
			})
		}
	},
	mounted(){
		this.getModules()
	}
}
</script>

<style lang="sass">
	.sub-title
		margin: 10px 0 30px 0
		font-size: 20px
	.m-t-20
		margin-top: 20px
	.year-division
		margin-top: 30px
		&::before
			content: ''
			position: absolute
			width: 80%
			left: 10%
			z-index: -1
			border-top: 1px dashed rgba(0,0,0,.2)
	.project
		img
			height: 100px
	.title-col
		margin: 10px 0 10px 20px
		font-size: 20px
		text-align: left
	.card-module
		.card-img
			max-height: 80px
		text-align: center
		vertical-align: middle
		background: linear-gradient(#3e9042,#8ca742)
		color: white
		padding: 20px
		border-radius: 12px
		transition: .5s ease
		box-shadow: 1px 1px 3px rgba(0,0,0,.3)
		cursor: pointer
		&:hover
			transform: scale(1.2)
			box-shadow: 1px 1px 10px rgba(0,0,0,.3)
</style>